import { toObjectMap } from "@@/utilities/dictionary";

const LIST = "LIST";
const SINGLE = "SINGLE";

type LIST = typeof LIST;
type SINGLE = typeof SINGLE;

const sectionDisplayTypes = [LIST, SINGLE] as const;
type SectionDisplayType = (typeof sectionDisplayTypes)[number];
const sectionDisplayTypesMap = toObjectMap<SectionDisplayType>([
    ...sectionDisplayTypes,
]);

export { sectionDisplayTypes, sectionDisplayTypesMap, LIST, SINGLE };
export type { SectionDisplayType };
